jQuery(document).ready(function ($) {
    $('.container-contrl').each(function () {
        const $container = $(this);

        $container.find('.tab-button').on('click', function () {
            const data = JSON.parse(localStorage.getItem('contrl-checkout')) || {};
            const canProceed = 'selectedPackage' in data &&
                'selectedContract' in data &&
                ('selectedSystem' in data || data.selectedPackage.name === 'Plus');
            const tab = $(this).data('tab');

            if (this.parentNode.id !== 'tablist') {
                if (canProceed) {
                    $container.find('.tab-active').removeClass('tab-active');
                    $(this).addClass('tab-active');
                    $container.find('#' + tab).addClass('tab-active');
                    $('html').scrollTop(0);
                    return;
                }
            }
            $container.find('.tab-active').removeClass('tab-active');
            $(this).addClass('tab-active');
            $container.find('#' + tab).addClass('tab-active');
        });
    });
});